(function () {
  const FORM_ID = 'StcxFR';
  const COMPANY_ID = 'U33dSk';
  const PROPERTY = 'gender (spol)';
  let selectedGender = null;
  let pending = null;
  let lastSynced = null;

  function validGender(value) {
    return value === 'moski' || value === 'zenska';
  }

  function syncProfile(email, gender, attempt) {
    if (lastSynced === email + ':' + gender || pending) return;

    pending = fetch('https://a.klaviyo.com/client/profiles?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: { email: email, properties: { [PROPERTY]: gender } }
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo profile update failed');
        lastSynced = email + ':' + gender;
      })
      .catch(function () {
        if (attempt < 4) {
          window.setTimeout(function () {
            syncProfile(email, gender, attempt + 1);
          }, 500 * (attempt + 1));
        }
      })
      .finally(function () {
        pending = null;
      });
  }

  window.addEventListener('klaviyoForms', function (event) {
    const detail = event.detail || {};
    if (detail.formId !== FORM_ID && detail.formID !== FORM_ID) return;
    if (detail.companyId && detail.companyId !== COMPANY_ID) return;

    const fields = detail.metaData || {};
    if (validGender(fields[PROPERTY])) selectedGender = fields[PROPERTY];

    if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;

    const email = typeof fields.$email === 'string' ? fields.$email.trim() : '';
    if (!email || !validGender(selectedGender)) return;

    syncProfile(email, selectedGender, 0);
    selectedGender = null;
  });
})();
